import styled from 'styled-components';

export const PersonTagListWrap = styled.div`
    display: block;
    width: 100%;
    overflow: auto;
`;
